import BaseButton from "Engine/base/ui/BaseButton";
import EntryPoint from "Engine/EntryPoint";

export default class BaseAutoPlayStartButton extends BaseButton {
    constructor(data, displayData) {
        super(data, displayData);

        this.enabled = true;
        this.actions = {
            click: {
                callback: this.onButtonClick, context: this,
            },
            touchend: {
                callback: this.onButtonClick, context: this,
            }
        }
    }

    onButtonClick() {
        EntryPoint.AutoPlaySettings.active = true;
    }
}